/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

Inject({ providedIn: 'root' });

export class FittingTreeViewService {
  private fittingTreeViewSubject = new BehaviorSubject<any>(null);
  fittingTreeView$ = this.fittingTreeViewSubject.asObservable();

  setFittingTreeViewInstance(fittingTreeView: any) {
    this.fittingTreeViewSubject.next(fittingTreeView);
  }
}
